import { createFileRoute, Outlet, Link, useRouterState } from "@tanstack/react-router";
import { PageHeader } from "@/components/ui/page-header";
import { cn } from "@/lib/utils";

export const Route = createFileRoute("/_authenticated/app/warehouse-map")({ component: Shell });

const tabs = [
  { to: "/app/warehouse-map", label: "Builder", exact: true },
  { to: "/app/warehouse-map/locations", label: "Locations" },
  { to: "/app/warehouse-map/heatmap", label: "Heatmap" },
  { to: "/app/warehouse-map/movement", label: "Movement" },
  { to: "/app/warehouse-map/slotting", label: "Slotting" },
];

function Shell() {
  const path = useRouterState({ select: (s) => s.location.pathname });
  return (
    <>
      <PageHeader title="Warehouse Map" description="Lay out your facility, label every location, and route work across it." />
      <div className="border-b border-border px-4 sm:px-6">
        <nav className="flex gap-1 -mb-px">
          {tabs.map((t) => {
            const active = t.exact ? path === t.to : path.startsWith(t.to);
            return (
              <Link
                key={t.to}
                to={t.to}
                className={cn(
                  "px-3 py-2 text-sm border-b-2 -mb-px transition-colors",
                  active
                    ? "border-primary text-foreground font-medium"
                    : "border-transparent text-muted-foreground hover:text-foreground",
                )}
              >
                {t.label}
              </Link>
            );
          })}
        </nav>
      </div>
      <Outlet />
    </>
  );
}